import { connect } from "react-redux";
import * as invoiceActions from "./actions";

//Used to format the dates correctly without timezone (ToDo add this globally somehow?)
import moment from "moment";

function mapStateToProps(state) {
  return {
    invoices: state.invoices.invoices,
    stInvoices: state.invoices.shortTermInvoices,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    /*getInvoices: () => {
			dispatch(invoiceActions.get_invoices());
		},*/

    removeInvoiceRow: (loanId, invoiceId, rowId, draft) => {
      dispatch(
        invoiceActions.remove_invoice_row(loanId, invoiceId, rowId, draft),
      );
    },

    changeInvoiceListPage: (page) => {
      dispatch(invoiceActions.change_invoice_list_page(page));
    },

    changeInvoiceListFilter: (type, key, value) => {
      dispatch(invoiceActions.change_invoice_list_filter(key, value));
    },

    getSTInvoices: () => {
      dispatch(invoiceActions.get_st_invoices());
    },

    changeSTInvoiceListPage: (page) => {
      dispatch(invoiceActions.change_st_invoice_list_page(page));
    },

    changeSTInvoiceListFilter: (type, key, value) => {
      dispatch(invoiceActions.change_st_invoice_list_filter(key, value));
    },

    registerPayment: (
      loanId,
      customerRefCode,
      staffRefCode,
      amount,
      receiveDate,
    ) => {
      receiveDate = moment(receiveDate).format("YYYY-MM-DD");
      dispatch(
        invoiceActions.register_invoice_payment(
          loanId,
          customerRefCode,
          staffRefCode,
          amount,
          receiveDate,
        ),
      );
    },
  };
}

export const invoicesConnector = connect(mapStateToProps, mapDispatchToProps);
